import React from 'react';
import { Line, Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

// Strikethrough "S" glyph for the message text-styles toolbar (not a Figma
// icon export; drawn to match the 24-viewBox stroke icons in this set).
export const StrikethroughIcon: React.FC<IconProps> = ({
  size = 24,
  color = '#020202',
  style,
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    overflow="visible"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path
      d="M16 4H9a3 3 0 0 0-2.83 4"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M14 12a4 4 0 0 1 0 8H6"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Line x1="4" y1="12" x2="20" y2="12" stroke={color} strokeWidth="2" strokeLinecap="round" />
  </Svg>
);

StrikethroughIcon.displayName = 'StrikethroughIcon';
